// Third Party
import { useRouter } from 'next/router';
import cx from 'classnames';
// Utils
import { routes } from '@routes';

// UI
import { Link } from '@components/link';

export const GiftCardSubnav: React.FC = () => {
  const router = useRouter();

  const isLookupActive = router.pathname === routes.giftCardLookup;
  const isPurchaseActive = router.pathname === routes.giftCardPurchase;

  return (
    <>
      <div className="sticky w-full top-0 z-30">
        <div className="flex flex-row justify-center w-full py-4 bg-primary-main shadow-md space-x-5 sm:space-x-8 items-center rounded-lg">
          <Link to={routes.giftCardPurchase}>
            <div
              className={cx(
                'text-white hover:underline',
                isPurchaseActive && 'underline underline-offset-4'
              )}
            >
              Buy Gift Card
            </div>
          </Link>

          <Link to={routes.giftCardLookup}>
            <div
              className={cx(
                'text-white hover:underline',
                isLookupActive && 'underline underline-offset-4'
              )}
            >
              Balance
            </div>
          </Link>
          <Link
            target="_blank"
            rel="noreferrer"
            isDark={true}
            to={routes.giftCardRedemption}
          >
            <div className="text-white hover:underline">Redeem</div>
          </Link>
        </div>
      </div>
    </>
  );
};
